import { Card } from './Card';

export enum Suit {
    Hearts = 'H',
    Diamonds = 'D',
    Clubs = 'C',
    Spades = 'S'
}

export interface ISortCards {
    asc?: boolean;
    suits?: Suit[],
    ignoreSuits?: boolean,
    highestNumber?: number,
}

export const SUIT_IMAGES = {
    H: require('../images/suits/hearts.png'),
    D: require('../images/suits/diamonds.png'),
    C: require('../images/suits/clubs.png'),
    S: require('../images/suits/spades.png'),
}

export function getSuitName (identifier: 'H'|'D'|'C'|'S') {
    switch (identifier) {
        case Suit.Hearts:   return "Hearts";
        case Suit.Diamonds: return "Diamonds";
        case Suit.Clubs:    return "Clubs";
        case Suit.Spades:   return "Spades";
        default:            return "Any";
    }
}

export function getAllSuits (): Suit[] {
    return [
        Suit.Hearts,
        Suit.Spades,
        Suit.Diamonds,
        Suit.Clubs,
    ];
}

export function sortCards(cards: Card[], options: ISortCards = {}) {
    const suitOrder = options.suits;
    const suitCards = 14;

    const highestNumber = options.highestNumber || 0;

    if (options.asc === undefined) {
        options.asc = true;
    }

    return cards.sort((a, b) => {
        let aNumber = (a.number === highestNumber)
            ? suitCards + 4
            : a.number as number;

        let bNumber = (b.number === highestNumber)
            ? suitCards + 4
            : b.number as number;

        if (a.number === highestNumber) {
            aNumber = suitCards * suitCards;
        }

        if (b.number === highestNumber) {
            bNumber = suitCards * suitCards;
        }

        const na = (options.asc) ? aNumber as number : suitCards - (aNumber as number);
        const nb = (options.asc) ? bNumber as number : suitCards - (bNumber as number);

        if(options.ignoreSuits) {
            return na - nb
        } else {
            return (
                (((suitOrder && suitOrder.indexOf(a.suit) * suitCards) || 0) + na) -
                (((suitOrder && suitOrder.indexOf(b.suit) * suitCards) || 0) + nb)
            )
        }
    })
}


// WEBPACK FOOTER //
// ./src/playing-cards/Suit.ts